<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button aria-controls="collapse0" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse0" data-bs-toggle="collapse" type="button">
                Periodieke uitkeringen
            </button>
        </h2>
        <div aria-labelledby="heading0" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse0">
            <div class="accordion-body">
                Bij periodieke uitkeringen gaat het om:<br/>
                <li>periodieke overheidsbijdragen voor uw eigen woning (uitzondering hierop zijn de uitkeringen volgens
                    de
                    Wet bevordering eigenwoningbezit)
                </li>
                <li>periodieke studietoelagen (niet de studiefinanciering van de DUO)</li>
                <li>lijfrente-uitkeringen waarop geen loonheffing is ingehouden en afkoopsommen daarvan</li>
                <li>vergoedingen voor bedrijfsbeëindiging die je krijgt van de Stichting Ontwikkelings- en
                    Saneringsfonds
                    voor de Landbouw
                </li>
                <li>periodieke uitkeringen door het staken van je onderneming</li>
                <li>periodieke uitkeringen in plaats van (arbeids)inkomsten die je misloopt</li>
                <li>periodieke uitkeringen door het staken of nalaten van werkzaamheden of diensten</li>
                <li>periodieke uitkeringen uit een lijfrente die je krijgt omdat je oudedagsreserve afneemt</li>
                <li>periodieke uitkeringen die je onverplicht krijgt van een rechtspersoon (bijvoorbeeld een periodieke
                    studietoelage van een familiestichting)
                </li>
                <li>periodieke uitkeringen als schadeloosstelling voor het mislopen van inkomsten of als bijdrage in
                    kosten
                    van levensonderhoud
                </li>
                <li>afkoopsommen van de genoemde periodieke uitkeringen</li>
                <li>jouw eigen deel van (de inkomsten uit) een onverdeelde boedel</li>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Periodieke overheidsbijdragen voor de eigen woning
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Het gaat om de volgende overheidsbijdragen:
                <li>jaarlijkse bijdragen voor premiekoopwoningen</li>
                <li>woninggebonden subsidies van de gemeente</li>
                <br/><br/>
                Was er nog een andere eigenaar van de woning op de datum van 1e bewoning? Dan geldt het volgende:
                <li>Als je nog met de mede-eigenaar in de woning woont, geef je een evenredig deel van de
                    overheidsbijdrage
                    aan. Ben je bijvoorbeeld voor de helft eigenaar? Dan geef je de helft van de overheidsbijdrage aan.
                    Dit
                    geldt ook als de bijdrage alleen op jouw naam wordt uitbetaald.
                </li>

                <li>Als de mede-eigenaar niet (meer) in de woning woont, geef je de volledige bijdrage aan.</li>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button aria-controls="collapse2" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2" data-bs-toggle="collapse" type="button">
                Kosten om een uitkering te krijgen of te houden
            </button>
        </h2>
        <div aria-labelledby="heading2" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse2">
            <div class="accordion-body">
                Heb je kosten gemaakt om een uitkering te krijgen of te houden? Bijvoorbeeld advocaatkosten,
                telefoonkosten, portokosten, reiskosten of incassokosten? Dan mag je voor de volgende uitkeringen deze
                kosten aftrekken:
                <li>bijstandsuitkeringen en vergelijkbare uitkeringen</li>
                <li>uitkeringen aan verzets- en oorlogsslachtoffers</li>
                <li>periodieke uitkeringen van een door je zelf gesloten verzekering bij invaliditeit, ziekte of een
                    ongeval
                </li>
                <li>uitkeringen uit een pensioenverzekering die je als ondernemer hebt afgesloten</li>
                <li>lijfrentetermijnen en lijfrente-afkoopsommen</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingRevisierente">
            <button aria-controls="collapseRevisierente" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseRevisierente" data-bs-toggle="collapse"
                    type="button">
                Afkoop lijfrente en revisierente
            </button>
        </h2>
        <div aria-labelledby="headingRevisierente" class="accordion-collapse collapse"
             data-bs-parent="#accordionRevisierente"
             id="collapseRevisierente">
            <div class="accordion-body">
                Kocht je een lijfrente af? Dan moet je in veel gevallen revisierente betalen. Deze bedraagt in dat geval 20% van het
                belaste deel van de afkoopsom. Dat is het bedrag van de afkoopsom verminderd met de niet-afgetrokken premies
                of stortingen. Voor de jaren vanaf 2010 mag je daarbij maximaal € 2.269 per kalenderjaar
                meetellen. Voor de jaren t/m 2009 mag je alle premies die je nog niet hebt afgetrokken, meetellen.
                <br/><br/>
                Heb je een 'verklaring niet-afgetrokken premies of bedragen' (saldoverklaring) aan de financiële
                instelling gestuurd voordat de afkoopsom werd uitgekeerd? Dan zal de financiële instelling al
                rekening gehouden hebben met de saldomethode. De revisierente bedraagt dan 20% van het bedrag
                van de jaaropgaaf van jouw financiële instelling.
                <br/><br/>
                Koop je de lijfrente af binnen 10 jaar na het einde van het kalenderjaar waarin je de lijfrente
                hebt afgesloten? Dan kan het zijn dat de revisierente lager is. Je berekent dat zelf met de
                <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/werk-en-inkomen/content/hulpmiddel-revisierente-berekenen"
                   target="_blank">Rekenhulp Revisierente</a> op belastingdienst.nl. Als het berekende bedrag lager is
                dan 20% van het aangegeven bedrag, vul je het lagere bedrag in.
                <br/><br/>
                In de volgende gevallen ben je geen revisierente verschuldigd. Vul dan een '0' in:
                <ul>
                    <li>Je hebt een lijfrente afgesloten vóór 16 oktober 1990. De premie mag daarna niet zijn
                        verhoogd, behalve als dat mogelijk was door een clausule in die polis.
                    </li>
                    <li>Je hebt een lijfrente afgesloten op 16 oktober 1990 of later, maar uiterlijk 31 december
                        1991. Er mag geen premie meer betaald zijn na 31 december 1991.
                    </li>
                    <li>De afkoopregeling kleine lijfrenten is van toepassing. Lees meer hierover in de fiscale
                        informatie van de Belastingdienst (zie onder).</li>
                    <li>Je koopt de lijfrente geheel of gedeeltelijk af vanwege arbeidsongeschiktheid.</li>
                </ul>
                <strong>Let op!</strong> Is jouw oud-regime-lijfrente aangepast aan de voorwaarden voor
                premieaftrek onder de Wet inkomstenbelasting 2001? En koop je dat deel van de
                lijfrenteverzekering af? Dan moet je over de afkoopsom van dat deel wél revisierente betalen.
                <br/><br/>
                <strong>Let op!</strong> Kocht je een lijfrente af vanwege arbeidsongeschiktheid en ontving je
                een hoger bedrag dan het voor jou geldende maximum? Dan ben je over dat hogere bedrag
                revisierente verschuldigd. Bereken de revisierente alleen over de afkoopsom min het voor jou
                geldende maximumbedrag.
            </div>
        </div>
    </div>
</div>

